import script from "./AuraChatFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./AuraChatFrame.vue?vue&type=script&setup=true&lang=js"

import "./AuraChatFrame.vue?vue&type=style&index=0&id=2384d8bf&lang=css"

const __exports__ = script;

export default __exports__